import { Component } from '@angular/core';
import { DemoComponent } from './demo/demo.component';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [DemoComponent],
  template: '<app-demo></app-demo>',
})
export class AppComponent {}
